var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dt-loading-main"},[_c('div',{staticClass:"dt-loading-center"},[_c('h4',[_c('div',{staticClass:"dt-loading-ellipsis"},[_c('span',{staticClass:"dt-loading-spot"})])])])])
}]

export { render, staticRenderFns }